export default __webpack_public_path__ + "static/media/IconDesc_SteelPipe.256.31e5ac1e.png";